<template>
  <div
    class="grid"
    :data-qa="dataQa">
    <TooltipedText
      :data-qa="dataQa + '-title'"
      :line-count="1"
      :value="title"/>
    <TooltipedText
      v-if="description"
      class="opacity-6 mt-2"
      :data-qa="dataQa + '-description'"
      :line-count="1"
      :line-height="1.5"
      :value="description"/>
  </div>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

export default {
  name: 'LotGroupTitle',
  components: {
    TooltipedText
  },
  props: {
    title: String,
    description: String,
    dataQa: {
      type: String,
      default: 'item-name'
    }
  },
}
</script>
<style scoped>

</style>
